<script setup>
/* eslint-disable */
import { useCouponsStore } from '@/stores/coupons';
import PreFixtureDoubleMarket from '@/components/pre_sports/highlights/PreFixtureDoubleMarket.vue'

const couponsStore = useCouponsStore();
const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
});

</script>

<template>
	<div class="live-tab-info competition-tab-main">
		<div id="competition" class="tab-content competetion-outer-main">

			<div class="live-info-outer">
				<div class="live-info-inner">
					<div class="live-info-team"></div>

					<div class="full-time-top top-title-dash " :class="{'totals_new-grid': primary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': primary_overview_market?.market_type == 'handicap_new'}">
						<span v-if="primary_overview_market?.market_type == 'totals_new' || primary_overview_market?.market_type == 'handicap_new'"/>
						<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
							<span v-if="odd?.length >= 1">{{ odd }}</span>
						</template>
					</div>

					<div class="match-goal-top top-title-dash" :class="{'totals_new-grid': secondary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': secondary_overview_market?.market_type == 'handicap_new'}">
						<span v-if="secondary_overview_market?.market_type == 'totals_new' || secondary_overview_market?.market_type == 'handicap_new'"/>
						<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
							<span  v-if="odd?.length >= 1">{{ odd }}</span>
						</template>
						<span class="bet-column-empty"></span>

					</div>

				</div>

				<PreFixtureDoubleMarket  v-for="fixture in couponsStore.nextHourFixturesPerHour" :key="fixture.id"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:fixture="fixture"
				/>
			</div>

		</div>
	</div>
</template>

<style scoped>
.live-tab-info {
	scrollbar-width: none !important;
}
</style>